import React from "react";

const BoldOnHover = ({ children, weight = "bold", isFullSize = false }) => {
  return (
    <span
      className={`bold-on-hover bold-on-hover--${weight} ${
        isFullSize ? "bold-on-hover--full-size" : ""
      }`}
      data-text={children}
    >
      {children}
    </span>
  );
};

export default BoldOnHover;
